export default __webpack_public_path__ + "static/media/CS_136.2090060f.png";